<template>
    <div>
    <h2> Pharaoh's Tomb:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Pharaohs Tomb')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/257631252/sswXUkif5dxlbL0tI_0i6g/original.jpg?163804170255" target="_blank">Download</a><br/>
    The Pharoah's Tomb is the Easy difficulty encounter with a CR of 12 on floor 3. It is split arena style, so monsters will at certain triggers such as entering new locations or defeating other monsters.
    <v-row>
        <v-col>
            <img id="Pharaohs Tomb" :src="require('../../../assets/Annotated_Pharaohs_Tomb_Map.png')"  contain width="850px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place on the prime material plane.</li>
            <li>The outside area is covered by a minor sandstorm and players can only see 80 ft outside. Once inside it is dim lighting and players can only see 40 feet..</li>
            <li>The outside is an unmeasurable height, but inside the tomb main area is 50 feet, and in the final 2 rooms it becomes 30 feet.</li>
            <li>While outside at the end of every minute players receive 8d6 bludgeoning damage and become blinded for 1 minute. They can make a DC 14 fortitude save to reduce the damage by half and negate the blind. The DC increases by 4 for each time the players have had to make it.</li>
            <li>While inside at the end of every minute players players must make a dc 16 will save or receive 8d6 negative energy damage and become cursed and receive a -4 to attack and saves for 1 minute. The DC increases by 4 for each time the players have had to make it.</li>
            <li>All the curses on this encounter end once they leave the encounter.</li>
            <li>Map is 25x76</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Cyan</li>
                <li>Area Of Interest: Green</li>
                <li>Monsters: Red</li>
                <li>Terrain of Note: White</li>
            </ul>                 
        </ul>
        <br/><br/>
        
    <h4>Monsters:</h4>
        <ul>
            <li><b>Combat 1 CR 12: </b> </li>
            Combat 1 starts as soon as the players enter the floor.
            <ul>
                <li><b>1) Harridan CR 12: </b> The harridan starts having already cast shield of faith on itself. Attempts to split the party up with blade barrier first round.</li>                
            </ul>            
            <br/>
            <li><b>Combat 2 CR 13: </b> </li>
            Combat 2 begins once players have entered 5 feet into tomb or is within emperor scorpions range.
            <ul>
                <li><b>2) Giant Emperor Scorpion CR 11: </b> Attempts to use ambush pit, players can roll perception checks against its +30 stealth.</li>
                <li><b>3) Death Worm Leviathan CR 11: </b> Is burrowed 30 feet underground, once emperor scorpion engages it will ascend to attack.</li>
            </ul>
            <br/>
            <li><b>Combat 3 CR 14: </b> </li>
            Combat 3 begins once players are within 40 feet of either mummy lord 
            <ul>
                <li><b>4) Mummy Lord CR 10: </b>Starts combat with divine power cast</li>
                <li><b>5) Black Jinni CR 12: </b> Black Jinni's vulnerability to recitation doesn't require a cleric or paladin, only a character who is either lawful or good.</li>
            </ul>
            <br/>
            <li><b>Combat 4 CR 16: </b> </li>
            Combat Begins once all players have entered into room, and the door slams shut behind them.
            <ul>
                <li><b>2x Mythic Sphinx Colossus CR 14: </b> Sphinx turns from its statue form into its base form to surprise the party once the door shuts.</li>
            </ul>
            <br/>
            <li><b>Combat 5 CR 17: </b> </li>
            Combat 5 begins as soon as door to final room is opened.
            <ul>
                <li><b>Mythic Lich CR 17: </b> Bursts from its sarcophagi. Enters having already cast freedom of movement and entropic shield, and as combat starts casts blade barrier mythic as an immediate action.</li>                
            </ul>
        </ul>
        <br/><br/>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Stats 50</b></li>
            <li><b>2) Weapon Enchantment 50</b></li>
            <li><b>3) Level Up 200</b> </li>
            <li><b>4) Perk 75</b></li>
            <li><b>5) Armor Enchantment 50</b></li>
            <li><b>6) Resurrective 75</b></li>
            <li><b>7) Stats 25</b></li>
            <li><b>8) Feat 125</b></li>
            <li><b>9) R+ Weapon Enchantment 125</b></li>
            <li><b>10) Resurrective 100</b></li>
            <li><b>11) E+ Weapon Enchantment 125: </b> Appears if players succeed the AoI 1 check</li>
            <li><b>12) E+ Perk 150: </b> Appears if players succeed the AoI 1 check</li>
            <li><b>13) Lvl+ Spell/Maneuver 60</b></li>
            <li><b>14) Metamagic Feat 150</b></li>
            <li><b>15) Feat 125</b></li>
            <li><b>16) Double Typed Maneuver </b></li>
            <li><b>17) E+ Stats 50: </b> Requires a survival or knowledge nature check DC 32 to obtain.</li>
            <li><b>18) R Perk 100 </b></li>
            <li><b>19) Typed Spell/Maneuver 60</b></li>
            <li><b>20) Armor Enchantment 100</b></li>
            <li><b>21) L+ Typed Weapon 125</b></li>
            <li><b>22) Stats 50</b></li>
            <li><b>23) E+ Stats 75: </b> Requires a DC 32 knowledge religion or survival check to use this blessed water to make enhance their body</li>
            <li><b>24) 4-8 Potions 50</b></li>
            <li><b>25) 4-8 Typed Potions 50: </b> Reqires a DC 32 heal or survival check to use this blessed water to make potions</li>
            <li><b>26) Ki Perk 125</b></li>
            <li><b>27) R+ Weapon Enchantment 125</b></li>
            <li><b>28) 2-4 Potions 25</b></li>
            <li><b>29) Feat 125: </b> Requires a DC 24 perform or stealth check</li>
            <li><b>S1) Small Gold Pile: </b> Once player approach statue they make make a knowledge religion check DC 17 to recognize this gold is cursed. Players must either make a DC 32 knowledge religion or spellcraft check to take gold without being cursed. If players choose to take gold anyway the player who took gold must make a will save dc 22 + gold piles taken or become cursed and get -2 to attack rolls and saving throws. This stacks with other curses in the encounter including itself.</li>
            <li><b>S2) Small Gold Pile: </b> Requires a DC 27 perception check to notice.</li>
            <li><b>M1) Medium Gold Pile: </b> Appears if players succeed AoI1 check.</li>
            <li><b>M2) Medium Gold Pile: </b> Requires a DC 22 perception check to notice.</li>
            <li><b>M3) Medium Gold Pile: </b> Requires a DC 32 perception check to notice, and a standard action to dig up.</li>
            <li><b>M4) Medium Gold Pile: </b> Under 10 feet of water, requires a DC 22 perception check to notice, and a DC 22 swim check to obtain. While in water player is subject to poison water</li>
            <li><b>L1) Large Gold Pile: </b> Gold is locked inside of a hidden chamber on the statue. Requires a DC 32 perception check to notice, once noticed a single player must make both a DC 22 knowledge religion and disable device to obtain.</li>
        </ul>
        <br/><br/>

        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Shrine to an Angry God: </b> This statue overlooks the main room with an angry glare. If players attempt to take gold from the shrine without first appeasing it they will become cursed. Once player approach statue they make make a knowledge religion check DC 23 to recognize this gold is cursed. Players must either make a DC 35 knowledge religion or spellcraft check to take gold without being cursed. If players choose to take a gold pile anyway the player who took gold must make a will save dc 22 + gold piles taken or become cursed and get -2 to attack rolls and saving throws for the rest of the floor. This stacks with other curses in the encounter including itself. Each pile of gold activates the curse individually. The curse DC increases based on gold taken regardless of which player actually took it. Only one knowledge check is required to appease statue and take the rest without being cursed.</li>
            <li><b>2) Cursed Door: </b> When players open door they must make a dc 29 knowledge religion check or when door opens it curses all players unless they make a DC 21 will save. Cursed players receive a -4 to attack rolls and saving throws. </li>
            <li><b>3) Poisoned Water: </b> To swim in water requires a DC 15 swim check. Every round a player ends their turn in the poisoned water they must make a fortitude save dc 16 +1 per round spent in water. If player fails they are poisoned and receive 1d6 strength damage once a round for 6 rounds. They can make a new save each round to end the affect and stop themselves from taking additional strength damage.</li>
        </ul>
        <br/><br/>        
        </v-col>
    </v-row>
    <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Cliffs: </b> There are two cliffs each rising 15 feet and requiring a DC 20 climb check. The first staircase rises 10 feet, and the other 30 is gained as the players reach the end of the statues. This means players cannot move off the sides of the path unless they succeed climb checks. </li>            
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>